import React from 'react';
import domainModel from 'domain-model';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Row, Col } from 'reactstrap';
import type { ProcurementArticle, CartRow } from 'domain-model/types/pcs';
import type { ArticleReference } from 'domain-model/types/oms';
import type { ShopConfig } from 'domain-model/types/supplier-gateway';
import ArticleQuantityInput from './ArticleQuantityInput';
import type { PersistedMultiCartState } from '../../reducers/persisted-multi-cart.reducer';
import {
  updateQuantityOnCartRow as _updateQuantityOnCartRow,
  type Authentication,
} from '../../actions/persisted-multi-cart.actions';

function ConnectedArticleQuantityInput({
  article,
  procurementArticle,
  cartRow,
  persistedMultiCart,
  updateQuantityOnCartRow,
  shopConfig,
  disabled,
}: {
  article: ArticleReference;
  procurementArticle?: ProcurementArticle;
  cartRow?: CartRow;
  persistedMultiCart: PersistedMultiCartState;
  updateQuantityOnCartRow: Function;
  shopConfig: ShopConfig;
  disabled?: boolean;
}) {
  const articleViewModel = domainModel.article.getViewModel(article);

  const warehouseStatus =
    domainModel.pricedArticle.warehouseStatus(articleViewModel);

  let cartKey;

  if (article.myOrderFullfillmentCenter) {
    cartKey = domainModel.cart.getCartKey({
      orderFullfillmentCenter: article.myOrderFullfillmentCenter,
      currency: article.currency,
    });
  }

  const cart = persistedMultiCart.carts[cartKey];

  const cartRows = (cart?.cartRows || []).filter(item => {
    if (procurementArticle) {
      return item.procurementArticle?.id === procurementArticle.id;
    }
    return (
      // @ts-expect-error we need to type reference types
      item.pricedArticle.id === article.id && !item.procurementArticle
    );
  });
  let disabledInput = false;
  if (!cartKey || disabled) {
    disabledInput = true;
  }

  let quantity = _.sumBy(cartRows, x => x.quantity!) || 0;

  if (cartRow) {
    quantity = cartRow.quantity || 0;
  }

  const submitInput = (name: string, value: number) => {
    updateQuantityOnCartRow(articleViewModel, value, procurementArticle);
  };

  return (
    <>
      {!warehouseStatus.isPossibleToOrder && (
        <Row>
          <Col className="text-center mb-2 mt-1" xs={12}>
            {warehouseStatus.text || 'Tillfälligt slut'}
          </Col>
        </Row>
      )}
      {warehouseStatus.isPossibleToOrder && (
        <ArticleQuantityInput
          article={articleViewModel}
          value={quantity}
          onChange={submitInput}
          disabled={disabledInput}
          shopConfig={shopConfig}
          cartRow={cartRow}
          showOrderUnitSelect
        />
      )}
    </>
  );
}

const mapStateToProps = ({
  persistedMultiCart,
  authentication,
  shopConfig,
}: {
  persistedMultiCart: PersistedMultiCartState;
  authentication: Authentication; // Replace 'any' with the actual type of 'authentication'
  shopConfig: ShopConfig; // Replace 'any' with the actual type of 'shopConfig'
}) => ({
  persistedMultiCart,
  sessionUser: authentication.sessionUser,
  shopConfig,
});

const mapDispatchToProps = {
  updateQuantityOnCartRow: _updateQuantityOnCartRow,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ConnectedArticleQuantityInput);
